/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebphasepublishing3Inputs */

const en_placewebphasepublishing3 = /** @type {(inputs: Placewebphasepublishing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing`)
};

const de_placewebphasepublishing3 = /** @type {(inputs: Placewebphasepublishing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Publishing" |
*
* @param {Placewebphasepublishing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphasepublishing3 = /** @type {((inputs?: Placewebphasepublishing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphasepublishing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphasepublishing3(inputs)
	return de_placewebphasepublishing3(inputs)
});
export { placewebphasepublishing3 as "placeWebPhasePublishing" }